/**
 * ArubaRouteGate — redirects users without an Aruba key to the setup page.
 *
 * This runs independently from the auth-required protected route so Aruba
 * gating works in both demo mode and real auth mode. If the auth bootstrap is
 * still in flight we render nothing to avoid a flash redirect.
 */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/stores/auth";

export function ArubaRouteGate() {
  const status = useAuth((s) => s.status);
  const user = useAuth((s) => s.user);
  const location = useLocation();

  if (status === "idle" || status === "loading") return null;
  if (!user) return <Outlet />;

  const hasArubaKey = user.arubaKeyConfigured === true;
  const onKeyPage = location.pathname === "/aruba/keys";

  if (!hasArubaKey && !onKeyPage) {
    const redirect = encodeURIComponent(
      `${location.pathname}${location.search}`,
    );
    return <Navigate to={`/aruba/keys?redirect=${redirect}`} replace />;
  }

  return <Outlet />;
}
